export class UserInfo_pObj {
    account: string;
    token: string;
}

export class UserInfo {
    
    accountNumber: Number;
    address1: String;
    address2: String;
    balance: Number;
    betMinAmount: Number;
    bf: Number;
    cardExpireDate: String;
    cardType: String;
    countryCode: String;
    createdTimestamp: String;
    currencyCode: String;
    customerIdReference: String;
    customerIdType: String;
    email: String;
    firstName: String;
    id: Number;
    idNumber: String;
    last4CreditCard: String;
    permitBet: String;
    permitDep: String;
    permitWth: String;
    phoneCountryCode: String;
    phoneNumber: String;
    postalCode: String;
    redeemAccount: String;
    redeemAccountName: String;
    redeemBank: String;
    redeemBranch: String;
    slipMinAmount: Number;
    status: Number;
    suburb: String;
    surname: String;
    title:string

    constructor(data: any) {
        this.accountNumber = data.accountNumber;
        this.address1 = data.address1;
        this.address2 = data.address2;
        this.balance = data.balance;
        this.betMinAmount = data.betMinAmount;
        this.bf = data.bf;
        this.cardExpireDate = data.cardExpireDate;
        this.cardType = data.cardType;
        this.countryCode = data.countryCode;
        this.createdTimestamp = data.createdTimestamp;
        this.currencyCode = data.currencyCode;
        this.customerIdReference = data.customerIdReference;
        this.customerIdType = data.customerIdType;
        this.email = data.email;
        this.firstName = data.firstName;
        this.id = data.id;
        this.idNumber = data.idNumber;
        this.last4CreditCard = data.last4CreditCard;
        this.permitBet = data.permitBet;
        this.permitDep = data.permitDep;
        this.permitWth = data.permitWth;
        this.phoneCountryCode = data.phoneCountryCode;
        this.phoneNumber = data.phoneNumber;
        this.postalCode = data.postalCode;
        this.redeemAccount = data.redeemAccount;
        this.redeemAccountName = data.redeemAccountName;
        this.redeemBank = data.redeemBank;
        this.slipMinAmount = data.slipMinAmount;
        this.status = data.status;
        this.suburb = data.suburb;
        this.surname = data.surname;
        this.title=data.title
    }
}